<template>
  <div class="modals">
    <div
      class="modal fade"
      id="modal-welcome"
      tabindex="-1"
      aria-labelledby="modal_welcomeLabel"
      aria-hidden="true"
      v-if="!isAuthenticate"
    >
      <div class="modal-dialog modal_welcome">
        <div class="modal-content">
          <div class="modal-header">
            <a href="javascript:;">
              <img src="@/assets/images/banner_welcome.png" />
            </a>
          </div>
          <div class="modal-body bcontent_1">
            <h4>{{ $t("modal.welcome.title") }}</h4>
            <div class="_des small-text">
              {{
                $t("modal.welcome.message", {
                  start_at: convertTimestampToDate(game.start_at),
                  end_at: convertTimestampToDate(game.end_at),
                })
              }}
            </div>
            <div class="_act">
              <a
                href="javascript:;"
                v-on:click="openPhoneModal"
                class="btn btn-x2"
                data-bs-dismiss="modal"
                ><span>{{ $t("modal.welcome.playNow") }}</span></a
              >
              <a
                href="javascript:;"
                v-on:click="openPhoneModalHistoryPath"
                data-bs-dismiss="modal"
                class="btn btn-x3"
                ><span>
                  {{ $t("modal.welcome.history") }}
                </span></a
              >
            </div>
          </div>
          <a
            href="javascript:void(0)"
            class="nav-link btn-close2"
            data-bs-dismiss="modal"
          >
            <img src="@/assets/images/_close.svg" />
          </a>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="modal-phone"
      tabindex="-1"
      aria-labelledby="modal_phoneLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal_phone">
        <div class="modal-content">
          <div class="modal-header">
            <a href="javascript:;">
              <img src="@/assets/images/banner_welcome.png" />
            </a>
          </div>
          <div class="modal-body bcontent_1">
            <h4>{{ $t("modal.phone_input.title") }}</h4>
            <div class="_des mt-4">
              <div class="form-group">
                <label
                  for="input-phone"
                  class="ms-2 position-absolute phone-input-label"
                >
                  <span class="h6 small bg-white px-1">{{
                    $t("modal.phone_input.input_label")
                  }}</span>
                </label>
                <ValidationObserver ref="phone_input">
                  <ValidationProvider
                    rules="required|phone_mask"
                    v-slot="{ errors }"
                  >
                    <input
                      inputmode="numeric"
                      v-model="currentPhone"
                      name="Số điện thoại"
                      class="form-control form-control-lg mt-2"
                      id="input-phone"
                      autocomplete="off"
                      v-mask="'#### ######'"
                    />
                    <!-- PHONE VALIDATING -->
                    <div
                      v-if="!isPhoneInvalid"
                      class="d-flex align-items-center mt-2"
                    >
                      <img
                        v-if="errors[0]"
                        src="@/assets/images/alert.png"
                        class="error_icon"
                      />
                      <span class="error_message">
                        {{ errors[0] }}
                      </span>
                    </div>
                    <!-- PHONE INVALID -->
                    <div
                      v-else-if="isPhoneInvalid"
                      class="d-flex align-items-center mt-2"
                    >
                      <img src="@/assets/images/alert.png" class="error_icon" />
                      <span class="error_message">
                        {{ $t("modal.phone_input.error") }}
                      </span>
                    </div>
                    <!-- PHONE LIMIT EXCEEDED -->
                    <div
                      v-if="isOtpRequestLimitExceeded"
                      class="d-flex align-items-center mt-2"
                    >
                      <img src="@/assets/images/alert.png" class="error_icon" />
                      <span class="error_message">
                        {{
                          $t("modal.phone_input.error_send_limit_exceeded", {
                            phone: currentPhone,
                            time_left: formatTime(otpTimeRemaing),
                          })
                        }}
                      </span>
                    </div>
                    <!-- WRONG OTP LOCK OUT -->
                    <div
                      v-if="isOtpRespondLimitExceeded"
                      class="d-flex align-items-center mt-2"
                    >
                      <img src="@/assets/images/alert.png" class="error_icon" />
                      <span class="error_message">
                        {{ $t("modal.otp_input.error_attempt_limit_exceeded") }}
                      </span>
                    </div>
                    <!-- PHONE ERROR OTHER -->
                    <div
                      v-if="sendOtpFail"
                      class="d-flex align-items-center mt-2"
                    >
                      <img src="@/assets/images/alert.png" class="error_icon" />
                      <span class="error_message">
                        {{
                          $t("modal.phone_input.error_other", {
                            phone: currentPhone,
                          })
                        }}
                      </span>
                    </div>
                  </ValidationProvider>
                </ValidationObserver>
              </div>
            </div>
            <div class="_act">
              <a
                href="javascript:;"
                v-on:click="onSubmitPhone"
                class="btn btn-x2"
                ><span>{{ $t("modal.phone_input.playNow") }}</span></a
              >
            </div>
          </div>
          <a
            href="javascript:void(0)"
            @click="handleGoBack(`#modal-phone`)"
            class="nav-link btn-close2"
          >
            <img
              style="width: 40px; height: 40px"
              class="border border-1 border-white rounded-circle p-2"
              src="@/assets/images/arrow-white.svg"
            />
          </a>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="modal-otp"
      tabindex="-1"
      aria-labelledby="modal_OtpLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal_otp">
        <div class="modal-content">
          <div class="modal-header">
            <a href="javascript:;">
              <img src="@/assets/images/banner_welcome.png" />
            </a>
          </div>
          <div class="modal-body bcontent_1">
            <h4>{{ $t("modal.otp_input.title") }}</h4>
            <div class="_des">
              {{
                $t("modal.otp_input.message", {
                  phone: "******" + currentPhone.replace(/\s/g, "").slice(6),
                })
              }}
              <div class="d-flex justify-content-center w-100 mt-2">
                <otp-input
                  ref="otpInput"
                  mode="group"
                  :isValid="isOtpValid"
                  :digits="digits"
                  @on-complete="onCompleteHandler"
                  @on-changed="onChangedHandler"
                  @on-paste="onPasteHandler"
                />
              </div>
              <!-- COUNTING DOWN - NO ERROR -->
              <div
                v-if="
                  otpTimeRemaing > 0 && isOtpValid && !isOtpRespondLimitExceeded
                "
                class="otp_expired mt-2"
              >
                {{
                  $t("modal.otp_input.expire", {
                    time_left: formatTime(otpTimeRemaing),
                  })
                }}
              </div>
              <!-- OPT INVALID OR EXPIRED -->
              <div
                v-if="
                  (otpTimeRemaing <= 0 || !isOtpValid) &&
                  !isOtpRespondLimitExceeded
                "
                class="d-flex flex-column align-items-start mt-2"
              >
                <div class="d-flex align-items-center">
                  <img src="@/assets/images/alert.png" class="error_icon" />
                  <span class="error_message">{{
                    $t("modal.otp_input.error")
                  }}</span>
                </div>
              </div>
              <!-- EXCEEDED NUMBER OF OTP ATTEMPTS -->
              <div
                v-if="isOtpRespondLimitExceeded"
                class="d-flex justify-content-between mt-2"
              >
                <div class="d-flex align-items-center">
                  <img src="@/assets/images/alert.png" class="error_icon" />
                  <span class="error_message">{{
                    $t("modal.otp_input.error_attempt_limit_exceeded")
                  }}</span>
                </div>
              </div>
            </div>
            <div class="_act">
              <a
                href="javascript:;"
                :class="{ disable: !isOtpValid || currentOtp.length < 6 }"
                class="btn btn-x2"
                v-on:click="onSubmitOtp"
                ><span>{{ $t("modal.otp_input.playNow") }}</span></a
              >
            </div>
            <div
              v-if="
                (otpTimeRemaing <= 0 || !isOtpValid) &&
                !isOtpRespondLimitExceeded
              "
              class="d-flex flex-column align-items-start mb-2"
            >
              <div class="d-flex justify-content-center w-100">
                <span
                  v-if="otpTimeRemaing <= 0"
                  v-on:click="handleResendOtp"
                  class="send_otp_btn"
                  >{{ $t("modal.otp_input.resend_otp") }}</span
                >
                <span v-if="otpTimeRemaing > 0" class="send_otp_btn">{{
                  $t("modal.otp_input.resend_otp_remaining_time", {
                    time_left: formatTime(otpTimeRemaing),
                  })
                }}</span>
              </div>
            </div>
          </div>
          <a
            href="javascript:void(0)"
            @click="handleGoBack(`#modal-otp`)"
            class="nav-link btn-close2"
          >
            <img
              style="width: 40px; height: 40px"
              class="border border-1 border-white rounded-circle p-2"
              src="@/assets/images/arrow-white.svg"
            />
          </a>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="modal-draw-success"
      tabindex="-1"
      aria-labelledby="modal_congrateLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal_common">
        <div class="modal-content">
          <div class="modal-header position-relative">
            <img
              src="@/assets/images/gift_header.svg"
              alt=""
              class="gift_header"
            />
            <img
              src="@/assets/images/gift_footer.svg"
              alt=""
              class="gift_footer"
            />
            <div href="javascript:;">
              <img src="@/assets/images/bg_x.png" />
              <img
                v-if="winGift && winGift.reward"
                :src="winGift.reward.logo"
                class="icon_q"
                style="max-width: 182px"
              />
            </div>
          </div>
          <div class="modal-body bcontent_x">
            <h4 v-html="$t('modal.gift.title')"></h4>
            <div class="box_congrate1">
              <p>{{ $t("modal.gift.title_gift") }}</p>
              <b v-if="winGift && winGift.reward">{{ winGift.reward.name }}</b>
            </div>
            <div class="_des">
              <div v-if="winGift && winGift.reward?.type === 1">
                  <div v-if="REWARD_TOP_UP_ID.includes(winGift.reward_id)">
                    {{ $t("modal.gift.message_1") }}
                    &nbsp;{{winPhone}}&nbsp;
                    {{ $t("modal.gift.message_2") }}.<br/>
                  </div>
                <div v-else>
                  {{$t('modal.gift.message_3')}} <a href="#" v-on:click="redirectToHistory"><strong>Lịch sử</strong></a>
                </div>
              </div>
              <div v-else-if="winGift && winGift.cart_id">
                {{$t('modal.gift.message_3')}} <a href="#" v-on:click="redirectToHistory"><strong>Lịch sử</strong></a>
              </div>
              {{ $t("modal.gift.hot_line") }}
              <a href="tel:1900299232">1900 299 232</a>
              {{ $t("modal.gift.hot_line_2") }}
            </div>
            <div class="_act">
              <template v-if="winGift && winGift.cart_id">
                <a
                  href="javascript:;"
                  class="btn btn-x2 p-l-r-15"
                  v-on:click="redirectToAddress"
                  data-bs-dismiss="modal"
                >
                  <span>{{ $t("modal.gift.get_gift_physical") }}</span>
                </a>
              </template>
              <template v-else>
                <a
                  href="javascript:;"
                  class="btn btn-x2"
                  data-bs-dismiss="modal"
                >
                  <span>{{ $t("modal.gift.confirm") }}</span>
                </a>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal-end-campaign"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal_common modal_common_size1">
        <div class="modal-content">
          <div class="modal-header">
            <a href="javascript:;">
              <img src="@/assets/images/bg_x1.png" />
              <img src="@/assets/images/clock.png" class="icon_q" />
            </a>
          </div>
          <div class="modal-body bcontent_x">
            <h4>{{ $t("modal.end_game.title") }}</h4>
            <div class="_des">
              {{ $t("modal.end_game.message") }}
            </div>
            <div class="_act">
              <a
                href="javascript:;"
                v-on:click="redirectToHome"
                data-bs-dismiss="modal"
                class="btn btn-x2"
                ><span>{{ $t("modal.end_game.back_home") }}</span></a
              >
              <a
                href="javascript:;"
                v-on:click="redirectToHistory"
                data-bs-dismiss="modal"
                class="btn btn-x3"
                ><span>
                  {{ $t("modal.end_game.history") }}
                </span></a
              >
            </div>
          </div>
          <a
            href="javascript:void(0)"
            class="nav-link btn-close2"
            data-bs-dismiss="modal"
          >
            <img src="@/assets/images/_close.svg" />
          </a>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal-out-of-quantity"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal_common modal_common_size1 joystick">
        <div class="modal-content">
          <div class="modal-header">
            <a href="javascript:;">
              <img src="@/assets/images/bg_x1.png" />
              <img src="@/assets/images/joystick.png" class="icon_q joystick" />
            </a>
          </div>
          <div class="modal-body bcontent_x">
            <h4>{{ $t("modal.out_of_quantity.title") }}</h4>
            <div class="_des">
              {{ $t("modal.out_of_quantity.message_1") }}
              {{ $t("modal.out_of_quantity.message_2") }}
            </div>
            <div class="_act">
              <a
                href="javascript:;"
                v-on:click="redirectToHome"
                class="btn btn-x2 w238"
              >
                <span>{{ $t("modal.out_of_quantity.get_quantity") }}</span>
              </a>
            </div>
          </div>
          <a
            href="javascript:void(0)"
            class="nav-link btn-close2"
            data-bs-dismiss="modal"
          >
            <img src="@/assets/images/_close.svg" />
          </a>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal-address-success"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal_common modal_common_size1 confetti">
        <div class="modal-content">
          <div class="modal-header">
            <a href="javascript:;">
              <img src="@/assets/images/bg_x3.png" />
              <img src="@/assets/images/confetti.png" class="icon_q" />
            </a>
          </div>
          <div class="modal-body bcontent_x">
            <h4>{{ $t("modal.address_success.title") }}</h4>
            <div class="_des">
              {{ $t("modal.address_success.message_1") }}
            </div>
            <div class="_act">
              <a href="javascript:;" data-bs-dismiss="modal" class="btn btn-x2">
                <span>{{ $t("modal.address_success.back_home") }}</span>
              </a>
            </div>
            <div
              class="_des"
              v-if="
                winGift && winGift.reward && winGift.reward.is_partner_gift == 2
              "
            >
              {{ $t("modal.address_success.hot_line_partner") }}
              <a href="tel:1900638079">1900 638 079</a>
              {{ $t("modal.address_success.hot_line_2") }}
            </div>
            <div class="_des" v-else>
              {{ $t("modal.address_success.hot_line") }}
              <a href="tel:1900299232">1900 299 232</a>
              {{ $t("modal.address_success.hot_line_2") }}
            </div>
          </div>
          <a
            href="javascript:void(0)"
            class="nav-link btn-close2"
            data-bs-dismiss="modal"
          >
            <img src="@/assets/images/_close.svg" />
          </a>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modal-error" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal_common modal_common_size1 joystick">
        <div class="modal-content">
          <div class="modal-header">
            <a href="javascript:;">
              <img src="@/assets/images/bg_x1.png" />
              <img src="@/assets/images/joystick.png" class="icon_q joystick" />
            </a>
          </div>
          <div class="modal-body bcontent_x">
            <h4>{{ $t("modal.more_error.title") }}</h4>
            <div class="_des">
              {{ $t("modal.more_error.message") }}
            </div>
          </div>
          <a
            href="javascript:void(0)"
            class="nav-link btn-close2"
            data-bs-dismiss="modal"
          >
            <img src="@/assets/images/_close.svg" />
          </a>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="menu_home_mobile"
      tabindex="-1"
      aria-labelledby="menu_home_mobileLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-fullscreen mh_mobile">
        <div class="modal-content">
          <div class="modal-body">
            <ul class="nav nav-pills">
              <li class="nav-item w-100 text-center">
                <a
                  href="javascript:void(0)"
                  data-bs-dismiss="modal"
                  v-on:click="redirectToHome"
                  class="nav-link btn-x1"
                  aria-current="page"
                  :class="{ active: this.$route.name === 'luckyDraw' }"
                >
                  <img src="@/assets/images/icon/icon.png" alt="" />
                  {{ $t("modal.menu.homepage") }}
                </a>
              </li>
              <li class="nav-item w-100 text-center">
                <a
                  href="javascript:void(0)"
                  data-bs-dismiss="modal"
                  v-on:click="redirectToRule"
                  class="nav-link btn-x1"
                  aria-current="page"
                  :class="{ active: this.$route.name === 'Rules' }"
                >
                  <img src="@/assets/images/the-le.png" />
                  {{ $t("modal.menu.rule") }}
                </a>
              </li>
              <li class="nav-item w-100 text-center">
                <a
                  href="javascript:void(0)"
                  data-bs-dismiss="modal"
                  v-on:click="redirectToHistory"
                  class="nav-link btn-x1"
                  :class="{ active: this.$route.name === 'History' }"
                >
                  <img src="@/assets/images/lich-su.png" />
                  {{ $t("modal.menu.history") }}
                </a>
              </li>
              <li class="nav-item w-100 text-center">
                <a
                  href="javascript:void(0)"
                  class="nav-link btn-x1 btn-close1 m-0"
                  data-bs-dismiss="modal"
                >
                  <img src="@/assets/images/close.svg" />
                </a>
              </li>
            </ul>
            <footer class="d-flex flex-wrap px-content-1">
              <p class="flex-grow-1">
                Hotline: <a href="tel:1900299232">1900 299 232</a>
              </p>
              <p>
                <a href="#" class="d-flex align-items-center">
                  <img src="@/assets/images/ub_logo.svg" />
                  <span>Powered by UrBox</span>
                </a>
              </p>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VoucherTypeEnum } from "@/enums";
import OtpInput from "@/components/Layouts/OtpInput";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { VALID_PHONE, VALID_OTP } from "@/stores/actions";
import {GAME_APP, REWARD_TOP_UP_ID} from "@/enums/modules/game";
import JwtService from "@/jwt-service";

const OTP_EXPIRED_TIME = 300;
const WRONG_OTP_BLOCKED_TIME = 1800;
let allIntervals = [];
const clearAllIntervals = () => {
  for (let i = 0; i < allIntervals.length; ++i) {
    clearInterval(allIntervals[i]);
  }
  allIntervals = [];
};

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Modals",
  components: {
    OtpInput,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapGetters(["game", "winGift"]),
    physicalVoucher() {
      return VoucherTypeEnum.PHYSICAL_VOUCHER;
    },
  },
  data() {
    return {
      currentPhone: "",
      currentOtp: "",
      isToHistory: false,
      isPhoneInvalid: false,
      sendOtpFail: false,
      isOtpRequestLimitExceeded: false,
      isOtpValid: true,
      isOtpRespondLimitExceeded: false,
      digits: 6,
      otpTimeRemaing: OTP_EXPIRED_TIME,
      otpBlockTimeRemaing: WRONG_OTP_BLOCKED_TIME,
      isAuthenticate: this.$store.state.isAuthenticate,
      winPhone: '',
      REWARD_TOP_UP_ID
    };
  },
  watch: {
    currentPhone(newValue, prevValue) {
      if (newValue !== prevValue) {
        this.isPhoneInvalid = false;
        this.isOtpRequestLimitExceeded = false;
        this.isOtpRespondLimitExceeded = false;
      }
    },
  },
  mounted() {
    let vm = this;

    // eslint-disable-next-line no-undef
    $("#modal-address-success").on("hidden.bs.modal", function () {
      vm.redirectToHome();
    });
    const phone = JwtService.getCustomerPhone();
    vm.winPhone = '****' + phone?.substring(phone.length - 4);
  },

  methods: {
    redirectToHistory() {
      let vm = this;
      vm.$router.push({
        name: "History",
        params: {
          isAuthenticate: true,
        },
      });
    },
    redirectToAddress() {
      let vm = this;
      vm.$router.push({
        name: "insertAddress",
        params: {
          isNeedInsertAddress: true,
        },
      });
    },
    redirectToRule() {
      let vm = this;
      vm.$router.push({ name: "Rules" });
    },
    redirectToHome() {
      let vm = this;
      vm.$router.push({ name: "luckyDraw" });
      $("#modal-out-of-quantity").modal("hide");
    },

    openPhoneModal() {
      $("#modal-phone").modal("show");
    },
    openPhoneModalHistoryPath() {
      $("#modal-phone").modal("show");
      this.isToHistory = true;
    },

    onSubmitPhone() {
      let vm = this;
      vm.isValidated("phone_input").then((response) => {
        if (response) {
          vm.$store
            .dispatch(VALID_PHONE, {
              phone_number: vm.currentPhone.replace(/\s/g, ""),
              game_id: GAME_APP.ID,
              app_id: GAME_APP.APP_ID,
              action: "login",
            })
            .then((res) => {
              if (res) {
                const { data } = res;
                if (data.code === 1) {
                  $("#modal-phone").modal("hide");
                  $("#modal-otp").modal("show");
                  clearAllIntervals();
                  vm.otpTimeRemaing = OTP_EXPIRED_TIME;
                  const otpInterval = setInterval(() => {
                    if (vm.otpTimeRemaing > 0) {
                      vm.otpTimeRemaing--;
                    } else {
                      clearInterval(otpInterval);
                    }
                  }, 1000);
                  allIntervals.push(otpInterval);
                  vm.isOtpRespondLimitExceeded = false;
                } else if (
                  data.code === 3 ||
                  data.code === "customer not found"
                ) {
                  vm.isPhoneInvalid = true;
                } else if (data.code === 7) {
                  vm.isOtpRequestLimitExceeded = true;
                  $("#modal-phone").modal("hide");
                  $("#modal-otp").modal("show");
                  if (vm.otpTimeRemaing === OTP_EXPIRED_TIME) {
                    const otpInterval = setInterval(() => {
                      if (vm.otpTimeRemaing > 0) {
                        vm.otpTimeRemaing--;
                      } else {
                        clearInterval(otpInterval);
                      }
                    }, 1000);
                    allIntervals.push(otpInterval);
                  }
                } else if (data.code === 8 || data.code === "block_send_otp") {
                  vm.isOtpRespondLimitExceeded = true;
                  vm.isOtpRequestLimitExceeded = false;
                  clearAllIntervals();
                  vm.otpBlockTimeRemaing = WRONG_OTP_BLOCKED_TIME;
                  const otpBlockInterval = setInterval(() => {
                    if (vm.otpBlockTimeRemaing > 0) {
                      vm.otpBlockTimeRemaing--;
                    } else {
                      clearInterval(otpBlockInterval);
                      vm.isOtpRespondLimitExceeded = false;
                    }
                  }, 1000);
                  allIntervals.push(otpBlockInterval);
                } else {
                  vm.sendOtpFail = true;
                }
              }
            });
        }
      });
    },

    handleResendOtp() {
      let vm = this;
      vm.$store.dispatch(VALID_PHONE, {
        phone_number: vm.currentPhone.replace(/\s/g, ""),
        game_id: GAME_APP.ID,
        app_id: GAME_APP.APP_ID,
        action: "login",
      });
      vm.otpTimeRemaing = OTP_EXPIRED_TIME;
      vm.currentOtp = "";
      vm.isOtpValid = true;
      vm.$refs.otpInput.clearInput();
      const otpInterval = setInterval(() => {
        if (vm.otpTimeRemaing > 0) {
          vm.otpTimeRemaing--;
        } else {
          clearInterval(otpInterval);
        }
      }, 1000);
    },

    onCompleteHandler(code) {
      this.currentOtp = code;
      this.isOtpValid = true;
    },

    onChangedHandler(lastEnteredCode) {
      // console.log("code changed", lastEnteredCode);
      if (lastEnteredCode === "") {
        this.currentOtp = "";
      }
    },

    onPasteHandler(code) {
      console.log("code pasted", code);
    },

    onClearHandler() {
      this.$refs.otpInput.clearInput();
    },

    onSubmitOtp() {
      let vm = this;
      if (vm.isOtpValid && vm.currentOtp.length === 6) {
        vm.$store
          .dispatch(VALID_OTP, {
            phone_number: vm.currentPhone.replace(/\s/g, ""),
            otp: vm.currentOtp,
            game_id: GAME_APP.ID,
            app_id: GAME_APP.APP_ID,
            action: "login",
          })
          .then((res) => {
            if (res && res.status === 200) {
              const { data } = res;
              if (data.code === 1) {
                $("#modal-otp").modal("hide");
                vm.$router.push({
                  name: vm.isToHistory ? "History" : "usingToken",
                  params: {
                    token: data.token,
                    customerPhone: JwtService.getCustomerPhone(),
                  },
                });
              } else if (data.code === 3) {
                vm.isOtpRequestLimitExceeded = false;
                vm.isOtpRespondLimitExceeded = true; //5 wrong try
              } else {
                vm.isOtpValid = false;
              }
            }
          });
      }
    },

    handleGoBack(modal) {
      let vm = this;
      $(modal).modal("hide");
      $(modal === "#modal-otp" ? "#modal-phone" : "#modal-welcome").modal(
        "show"
      );
      if (modal === "#modal-phone") {
        vm.isPhoneInvalid = false;
        vm.currentPhone = "";
      }
      if (modal === "#modal-otp") {
        vm.$refs.otpInput.clearInput();
        vm.isOtpValid = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.p-l-r-15 {
  padding: 0 15px !important;
}
</style>
